import { FC, useEffect, useRef, useState } from "react";
import { ChatWindowTitle } from "./ChatWindowTitle";
import { useChatStore } from "../../stores/ChatStore";
import { toAbsoluteUrl } from "../../_metronic/helpers";
import { AddPipeline } from "../Pipelines/BtnActionAddPipelineDropdown/AddPipeline";
import Swal from "sweetalert2";
import { AddMerchant } from "../Merchants/AddMerchant";
import { ChatMessageList } from '../../components/Chat/ChatMessage/ChatMessageList'
import { ChatAttachmentModal } from "./ChatAttachmentModal";
import { MasterLog } from "../Pipelines/Logs/MasterLog";
import moment from 'moment';
import useUser from "../../hooks/User";
import { DetailContactChat } from "./DetailContact";
import ForwardFooter from "./ChatFooter/ForwardFooter";
import { ChatInput } from "./ChatFooter/ChatInput";
import { useSettingsStore } from "../../stores/SettingsStore";
import { isActiveSession, isShowBtnCreateSession, isShowBtnEndSession, isViewOnlyChat } from "../../functions/chat";
import { ChatGroupMessage, ChatMerchant, ChatMessage } from "../../interfaces/Chat/Chat";
import { AddLog } from "../Pipelines/Logs/AddLog";
import { usePipelineStore } from "../../stores/PipelineStore";
import useSWR from "swr";
import axios from "axios";
import useAccessToken from "../../hooks/AccessToken";
import { Pipeline } from "../../interfaces";
import useModalEffect from "../../hooks/useModalEffect";
import { takeSessionChat } from "../../api/ChatCRUD";
import { useIntl } from "react-intl";
import { EndSessionChat } from "./Modal/EndSessionChat";
import { SwitchSessionChat } from "./Modal/SwitchSessionChat";
import useModalEffectResponsive from "../../hooks/useModalEffectResponsive";
import { Merchant } from "../../interfaces/Merchant";
import { UpdateMerchant } from "../Merchants/UpdateMerchant";
import { getDetailMerchants } from "../../api/MerchantsCRUD";
import { useMerchantStore } from "../../stores/MerchantStore";
import { SettingMultiMerchants } from "../../interfaces/Settings";
import useCheckIsMobile from "../../hooks/useCheckIsMobile";
import { ChatGroupMessageList } from "./ChatMessage/ChatGroupMessageList";
import { ChatGroupWindowTitle } from "./ChatGroupWindowTitle";
import { Dropdown, IconButton } from 'rsuite';
import { ChatGroupInput } from "./ChatFooter/ChatGroupInput";
import { DetailGroupContactChat } from "./DetailGroupContact";
import { UpdateGroupMessageBubble } from "./Modal/UpdateGroupMessageBubble";
import { UpdateMessageBubble } from "./Modal/UpdateMessageBubble";

interface Props {
    handleIntSync: (isFirst: boolean, isNew: boolean, type: 'chat' | 'chat-group', dataRoom: ChatMessage | ChatGroupMessage) => void
}

const ChatWindow: FC<Props> = ({ handleIntSync }) => {
    const {
        socket, showChat, showChatGroup, setShowChat, setShowModalUpdateGroupMessage, selectMessage,
        phoneNumber, messages, setMessages, selectGroupMessage, setShowModalUpdateMessage, setShowChatGroup,
        selectedChatPhone, menuActive, setGroupID, showModalUpdateGroupMessage, showModalUpdateMessage,
        setListChatMessages, setListChatRooms, setPhoneNumber, setIsOpenCheckBoxGroupForward,
        chatSelectedPipeline, listChatRooms, listChatAgents, isOpenCheckBoxGroupForward,
        attachmentMessageId, attachmentUrl, isOpenDetailGroupContact, setIsOpenDetailGroupContact,
        isOpenDetailContact, setIsOpenDetailContact, isOpenCheckBoxForward, setIsOpenCheckBoxForward
    } = useChatStore()
    const intl = useIntl()
    const user = useUser()
    const token = useAccessToken()
    const { isMobile } = useCheckIsMobile()
    const { multiPipelines, setSelectMultiPipeline } = usePipelineStore()
    const { multiMerchants, setSelectMultiMerchant } = useMerchantStore()
    const logsModalRef = useRef<HTMLDivElement | null>(null);
    const { settings } = useSettingsStore()
    const [dataChatPipeline, setDataChatPipeline] = useState<Pipeline | null>(null);
    const [showAddLogModal, setShowAddLogModal] = useState<boolean>(false);
    const [showMasterLogModal, setShowMasterLogModal] = useState<boolean>(false);
    const [showAddPipelineModal, setShowAddPipelineModal] = useState<boolean>(false);
    const [showUpdateMerchantModal, setShowUpdateMerchantModal] = useState<boolean>(false);
    const [showEndSessionModal, setShowEndSessionModal] = useState<boolean>(false);
    const [showSwitchSessionModal, setShowSwitchSessionModal] = useState<boolean>(false);
    const [selectMerchant, setSelectMerchant] = useState<Merchant>();
    const checkMenuActive = (menuActive === "chat" && isOpenDetailContact) || (menuActive === "chat-group" && isOpenDetailGroupContact)

    const fetcher = (url: string) => axios.get(url, {
        headers: {
            'X-Auth-token': token
        }
    }).then(res => res.data.data)

    const API_URL = process.env.REACT_APP_API_URL
    const { data: detailPipeline = {}, isLoading: detailPipelineLoading } = useSWR((chatSelectedPipeline && Object.keys(chatSelectedPipeline).length > 0) ? `${API_URL}v2/lead/${chatSelectedPipeline.id}` : null, fetcher, { revalidateOnFocus: false, revalidateOnReconnect: false })

    useEffect(() => {
        socket.on("editChat", (message_id: string, new_message: string, as: string, phone: string) => {
            const { listChatMessages } = useChatStore.getState();
            let tempChatMessages = { ...listChatMessages };
            const key = `${phone}-${as}`;
            const indexMessage = tempChatMessages[key]?.findIndex((chat) => chat.id === message_id)
            const updateAt = moment().format("YYYY-MM-DD HH:mm:ss")

            setMessages((prevMessages) => {
                if (!prevMessages[indexMessage]) return prevMessages; // Hindari error jika index tidak valid

                if (phoneNumber === key) {
                    const updatedMessages = [...prevMessages]
                    updatedMessages[indexMessage].message = new_message
                    updatedMessages[indexMessage].action = { isEditing: false }
                    updatedMessages[indexMessage].updatedAt = updateAt

                    return updatedMessages;
                }

                return prevMessages;
            });

            setListChatRooms((prevMessages) => {
                if (!prevMessages) return prevMessages; // Hindari error jika index tidak valid

                const updatedMessages = { ...prevMessages }
                if (phoneNumber === key && updatedMessages[key].chat.id === message_id) {
                    updatedMessages[key].chat.message = new_message;
                    updatedMessages[key].chat.action = { isEditing: false }
                    updatedMessages[key].chat.updatedAt = updateAt

                    return updatedMessages;
                }

                return prevMessages;
            })

            setListChatMessages((prevMessages) => {
                if (!prevMessages[key][indexMessage]) return prevMessages; // Hindari error jika index tidak valid

                const updatedMessages = { ...prevMessages }
                updatedMessages[key][indexMessage].message = new_message
                updatedMessages[key][indexMessage].action = { isEditing: false }
                updatedMessages[key][indexMessage].updatedAt = updateAt

                return updatedMessages;
            })
        })

        socket.on("unsendChat", (message_id: string, as: string, phone: string) => {
            const { listChatMessages, listChatRooms } = useChatStore.getState();
            const key = `${phone}-${as}`;
            const updateMessages = listChatMessages[key].filter((message) => message.id !== message_id)
            setMessages((prevMessages) => {
                if (phoneNumber === key) {
                    return updateMessages
                }

                return prevMessages
            })
            setListChatMessages((prevMessages) => ({
                ...prevMessages,
                [key]: updateMessages
            }))

            let tempChatRooms = { ...listChatRooms };
            tempChatRooms[key].chat = updateMessages[updateMessages.length - 1]
            const worker = new Worker(new URL('../../app/pages/chat/SortChatRoomWorker.ts', import.meta.url));
            worker.postMessage({ data: tempChatRooms });
            worker.onmessage = (event) => {
                const { data } = event.data;
                setListChatRooms(() => data);
                worker.terminate();
            };
        })

        socket.on("editGroupChat", (message_id: string, new_message: string, as: string, groupId: string) => {
            const { listChatGroupMessages, setGroupMessages, groupID, setListChatGroupRooms, setListChatGroupMessages } = useChatStore.getState();
            let tempChatMessages = { ...listChatGroupMessages };
            const key = `${groupId}|${as}`;
            const indexMessage = tempChatMessages[key]?.findIndex((chat) => chat.id === message_id)
            const updateAt = moment().format("YYYY-MM-DD HH:mm:ss")

            setGroupMessages((prevMessages) => {
                if (!prevMessages[indexMessage]) return prevMessages; // Hindari error jika index tidak valid

                if (groupID === key) {
                    const updatedMessages = [...prevMessages]
                    updatedMessages[indexMessage].message = new_message
                    updatedMessages[indexMessage].action = { isEditing: false }
                    updatedMessages[indexMessage].updatedAt = updateAt

                    return updatedMessages;
                }

                return prevMessages;
            });

            setListChatGroupRooms((prevMessages) => {
                if (!prevMessages) return prevMessages; // Hindari error jika index tidak valid

                const updatedMessages = { ...prevMessages }
                if (groupID === key && updatedMessages[key].chat.id === message_id) {
                    updatedMessages[key].chat.message = new_message;
                    updatedMessages[key].chat.action = { isEditing: false }
                    updatedMessages[key].chat.updatedAt = updateAt

                    return updatedMessages;
                }

                return prevMessages;
            })

            setListChatGroupMessages((prevMessages) => {
                if (!prevMessages[key][indexMessage]) return prevMessages; // Hindari error jika index tidak valid

                const updatedMessages = { ...prevMessages }
                updatedMessages[key][indexMessage].message = new_message
                updatedMessages[key][indexMessage].action = { isEditing: false }
                updatedMessages[key][indexMessage].updatedAt = updateAt

                return updatedMessages;
            })
        })

        socket.on("unsendGroupChat", (message_id: string, as: string, groupId: string) => {
            const { listChatGroupMessages, listChatGroupRooms, setGroupMessages, setListChatGroupMessages, setListChatGroupRooms, groupID } = useChatStore.getState();
            const key = `${groupId}|${as}`;
            const updateMessages = listChatGroupMessages[key].filter((message) => message.id !== message_id)
            setGroupMessages((prevMessages) => {
                if (groupID === key) {
                    return updateMessages
                }

                return prevMessages
            })
            setListChatGroupMessages((prevMessages) => ({
                ...prevMessages,
                [key]: updateMessages
            }))

            let tempChatRooms = { ...listChatGroupRooms };
            tempChatRooms[key].chat = updateMessages[updateMessages.length - 1]
            const worker = new Worker(new URL('../../app/pages/chat/SortChatRoomWorker.ts', import.meta.url));
            worker.postMessage({ data: tempChatRooms });
            worker.onmessage = (event) => {
                const { data } = event.data;
                setListChatGroupRooms(() => data);
                worker.terminate();
            };
        })

        return () => {
            socket.off("editChat");
            socket.off("unsendChat");
            socket.off("editGroupChat");
            socket.off("unsendGroupChat");
        };
    }, [messages])

    useEffect(() => {
        if (!detailPipelineLoading && chatSelectedPipeline && Object.keys(detailPipeline).length > 0 && Object.keys(chatSelectedPipeline).length > 0) {
            setDataChatPipeline(detailPipeline)

            let data = multiPipelines.find(item => item.id === chatSelectedPipeline.template.id)
            if (data) setSelectMultiPipeline(data)
            else setDataChatPipeline(null)
        } else {
            setDataChatPipeline(null)
        }
    }, [chatSelectedPipeline, multiPipelines, detailPipeline])

    // modal-backdrop child ke dua
    useEffect(() => {
        const backdrops = document.querySelectorAll('.modal-backdrop.show');
        let targetElement = null;

        backdrops.forEach((el) => {
            const parent = el.parentElement;
            const children = Array.from(parent?.children || []);
            const secondLastChild = children[children.length - 2];

            if (el === secondLastChild) {
                targetElement = el;
            }
        });

        if (targetElement) {
            (targetElement as HTMLDivElement).style.zIndex = '1050' as any;
        }
    }, [showAddLogModal, showMasterLogModal])

    useModalEffect({
        showModal: showAddPipelineModal,
        setShowModal: setShowAddPipelineModal,
        modalId: 'add-pipeline-modal'
    })

    useModalEffect({
        showModal: showUpdateMerchantModal,
        setShowModal: setShowUpdateMerchantModal,
        modalId: `update-merchant-modal`
    })

    useModalEffect({
        showModal: showEndSessionModal,
        setShowModal: setShowEndSessionModal,
        modalId: 'end-session-chat-modal'
    })

    useModalEffect({
        showModal: showSwitchSessionModal,
        setShowModal: setShowSwitchSessionModal,
        modalId: 'switch-session-chat-modal'
    })

    useModalEffect({
        showModal: showAddLogModal,
        setShowModal: setShowAddLogModal,
        modalId: 'tambah-log-modal'
    })

    useModalEffect({
        showModal: showMasterLogModal,
        setShowModal: setShowMasterLogModal,
        modalId: 'logs-modal'
    })

    useModalEffect({
        showModal: showModalUpdateMessage,
        setShowModal: setShowModalUpdateMessage,
        modalId: `update-message-bubble-modal`
    })

    useModalEffect({
        showModal: showModalUpdateGroupMessage,
        setShowModal: setShowModalUpdateGroupMessage,
        modalId: `update-group-message-bubble-modal`
    })

    useModalEffectResponsive({
        modalIdPrimary: 'logs-modal',
        modalIdSecondary: 'tambah-log-modal',
        showModalSeconday: showMasterLogModal,
        setShowModalSecondary: setShowMasterLogModal
    })

    const handleBackButton = () => {
        if (menuActive === 'chat') {
            setPhoneNumber('')
            setShowChat(false)
        } else {
            setGroupID('')
            setShowChatGroup(false)
        }
    }

    const handleTakeSession = async () => {
        const { listChatMessages } = useChatStore.getState();
        const lastMessage = listChatMessages[phoneNumber][listChatMessages[phoneNumber].length - 1]
        listChatRooms[phoneNumber].loading = true

        try {
            const res = await takeSessionChat(phoneNumber.split('-')[0], lastMessage.fromMe, selectedChatPhone[0].id, token)
            if (res.data.success) {
            }
        } catch (error: any) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                heightAuto: false,
                text: error.response.data.message,
            })
        } finally {
            listChatRooms[phoneNumber].loading = false
            setListChatRooms(() => listChatRooms)
        }
    }

    const showUpdateMerchant = () => {
        return phoneNumber && listChatRooms[phoneNumber].merchants?.length !== 0 && settings.feature_merchant && user.data.permission_merchant_update !== "NONE"
    }

    const handleClickUpdateMerchant = async (merchant: ChatMerchant) => {
        const data: SettingMultiMerchants | undefined = multiMerchants.find(item => item.id === merchant.template.id)
        setSelectMultiMerchant(data!)

        try {
            const res = await getDetailMerchants(token, merchant.id)
            if (res.data.success) {
                setSelectMerchant(res.data.data)
                setShowUpdateMerchantModal(true)
            }
        } catch (error: any) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                heightAuto: false,
                text: error.response.data.message,
            })
        }
    }

    const renderIconButton = (props: any, ref: any) => {
        return (
            <IconButton {...props} ref={ref} icon={<i className="bi bi-three-dots fs-2"></i>} />
        );
    };

    return (
        <div className="row">
            <div className={`card card-custom ${isMobile && checkMenuActive ? "d-none" : checkMenuActive ? "col-md-6 col-lg-6 col-xl-6" : "col-12"}`} style={{ maxHeight: "calc(100vh - 1rem)", height: "calc(100vh - 1rem)", position: 'relative' }}>
                <div className="card-header p-2" style={{ position: 'sticky', top: '0', zIndex: 1, minHeight: 'fit-content', maxHeight: 'fit-content', backgroundColor: 'white' }}>
                    {
                        menuActive === "chat" ?
                            <div className="d-flex justify-content-between w-100" style={{ height: 'fit-content', backgroundColor: 'white' }}>
                                {
                                    !isViewOnlyChat(settings, user, selectedChatPhone, listChatAgents[phoneNumber]) ?
                                        <>
                                            <div className="d-flex">
                                                <i className="fas fa-arrow-circle-left d-xl-none mt-3 me-3" onClick={handleBackButton} role="button" style={{ fontSize: "25px" }}></i>
                                                <ChatWindowTitle setOpenDetailContact={setIsOpenDetailContact} />
                                            </div>
                                            <div className="mt-1">
                                                <Dropdown renderToggle={renderIconButton} placement="bottomEnd">
                                                    {phoneNumber && listChatRooms[phoneNumber].merchants?.length !== 0 && settings.feature_pipeline && user.data.permission_pipeline_create !== "NONE" ? (
                                                        <Dropdown.Item>
                                                            <div onClick={() => setShowAddPipelineModal(true)} className="menu-link flex-stack px-3">
                                                                {intl.formatMessage({ id: "FORM.LABEL.ADD_GENERAL" }, { title: settings.pipeline_title })}
                                                            </div>
                                                        </Dropdown.Item>
                                                    ) : phoneNumber && listChatRooms[phoneNumber].merchants?.length === 0 && settings.feature_merchant && user.data.permission_merchant_create !== "NONE" ? (
                                                        <Dropdown.Item>
                                                            <div data-bs-toggle="modal" data-bs-target={`#add-merchant-modal`} className="menu-link flex-stack px-3">
                                                                {intl.formatMessage({ id: "FORM.LABEL.ADD_GENERAL" }, { title: settings.merchant_title })}
                                                            </div>
                                                        </Dropdown.Item>
                                                    ) : <></>}

                                                    {
                                                        showUpdateMerchant() &&
                                                        <Dropdown.Menu title={intl.formatMessage({ id: "FORM.LABEL.GENERAL_EDIT" }, { title: settings.merchant_title })} style={{ left: "auto", right: "100%" }}>
                                                            {phoneNumber && listChatRooms[phoneNumber].merchants.map((merchant: ChatMerchant) => (
                                                                <Dropdown.Item>
                                                                    <div className="menu-link px-3 d-flex flex-column align-items-start" onClick={() => handleClickUpdateMerchant(merchant)}>
                                                                        {merchant.name}
                                                                        <small>{merchant.template.name}</small>
                                                                    </div>
                                                                </Dropdown.Item>
                                                            ))}
                                                        </Dropdown.Menu>
                                                    }

                                                    {phoneNumber && dataChatPipeline !== null && settings.feature_pipeline && user.data.permission_pipeline_log_create !== "NONE" && (
                                                        <Dropdown.Item>
                                                            <div className="menu-link px-3" onClick={() => setShowMasterLogModal(true)}>
                                                                {intl.formatMessage({ id: "FORM.ACTION.ADD_LOG" })}
                                                            </div>
                                                        </Dropdown.Item>
                                                    )}

                                                    {settings.chat_version === 'v2' && isActiveSession(listChatAgents[phoneNumber], user, settings) && (
                                                        <Dropdown.Item>
                                                            <div className="menu-link px-3" onClick={() => setShowSwitchSessionModal(true)}>
                                                                {intl.formatMessage({ id: "FORM.LABEL.SWITCH_SESSION" })}
                                                            </div>
                                                        </Dropdown.Item>
                                                    )}

                                                    {isShowBtnEndSession(listChatAgents[phoneNumber], user) && (
                                                        <Dropdown.Item>
                                                            <div className="menu-link px-3 text-danger" onClick={() => setShowEndSessionModal(true)}>
                                                                {intl.formatMessage({ id: "FORM.LABEL.END_SESSION" })}
                                                            </div>
                                                        </Dropdown.Item>
                                                    )}
                                                </Dropdown>
                                            </div>
                                        </>
                                        :
                                        <div className="d-flex">
                                            <i className="fas fa-arrow-circle-left d-xl-none mt-3 me-3" onClick={handleBackButton} role="button" style={{ fontSize: "25px" }}></i>
                                            <ChatWindowTitle setOpenDetailContact={setIsOpenDetailContact} />
                                        </div>
                                }
                            </div>
                            :
                            <div className="row w-100" style={{ height: 'fit-content', backgroundColor: 'white' }}>
                                <div className="col-12 d-flex">
                                    <i className="fas fa-arrow-circle-left d-xl-none mt-3 me-3" onClick={handleBackButton} role="button" style={{ fontSize: "25px" }}></i>
                                    <ChatGroupWindowTitle setOpenDetailContact={setIsOpenDetailGroupContact} />
                                </div>
                            </div>
                    }
                </div>

                {menuActive === "chat" && showChat ? (
                    <>
                        <ChatMessageList handleIntSync={handleIntSync} />
                        {!isViewOnlyChat(settings, user, selectedChatPhone, listChatAgents[phoneNumber]) &&
                            isShowBtnCreateSession(settings, listChatRooms[phoneNumber], listChatAgents[phoneNumber]) && (
                                <div className="card-footer" style={{ padding: "0rem 2.25rem", position: 'sticky', bottom: 0 }}>
                                    {isActiveSession(listChatAgents[phoneNumber], user, settings) ? (
                                        <>
                                            {isOpenCheckBoxForward ? (
                                                <ForwardFooter
                                                    onCancel={() => setIsOpenCheckBoxForward(false)}
                                                    type='chat'
                                                />
                                            ) : (
                                                <ChatInput />
                                            )}
                                        </>
                                    ) : (
                                        <button
                                            type="button"
                                            className="btn btn-success w-100"
                                            onClick={handleTakeSession}
                                            style={{ backgroundColor: "#50cd89", color: "white" }}
                                            disabled={listChatRooms[phoneNumber].loading}
                                            data-kt-indicator={listChatRooms[phoneNumber].loading ? "on" : "off"}
                                        >
                                            <span className="indicator-label">
                                                {intl.formatMessage({ id: "FORM.LABEL.START_SESSION" })}
                                            </span>
                                            <span className="indicator-progress">
                                                Loading...{" "}
                                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                            </span>
                                        </button>
                                    )}
                                </div>
                            )}
                    </>
                ) : menuActive === "chat-group" && showChatGroup ? (
                    <>
                        <ChatGroupMessageList handleIntSync={handleIntSync} />
                        {!(selectedChatPhone.length > 1 || selectedChatPhone.some(item => item.scope === "chat_view")) && (
                            <div className="card-footer" style={{ padding: "0rem 2.25rem", position: 'sticky', bottom: 0 }}>
                                {isOpenCheckBoxGroupForward ? (
                                    <ForwardFooter
                                        onCancel={() => setIsOpenCheckBoxGroupForward(false)}
                                        type='chat-group'
                                    />
                                ) : (
                                    <ChatGroupInput />
                                )}
                            </div>
                        )}
                    </>
                ) : (
                    <div className="card-body">
                        <div className="center-overlay" style={{ background: "rgba(255, 255, 255, 1)" }}>
                            <img
                                src={toAbsoluteUrl("/media/logos/wooblazz-chat.png")}
                                style={{ height: "20%" }}
                                alt=""
                            />
                        </div>
                    </div>
                )}


                {
                    phoneNumber && dataChatPipeline !== null && settings.feature_pipeline && showAddLogModal && menuActive === "chat" &&
                    <AddLog showModal={showAddLogModal} setShowModal={setShowAddLogModal} lead={dataChatPipeline} showAddLogButton={false} showMasterLogModal={showMasterLogModal} />
                }

                {
                    phoneNumber && dataChatPipeline !== null && settings.feature_pipeline && menuActive === "chat" &&
                    <div className={`modal fade ${showAddLogModal ? 'hide' : 'show'}`} tabIndex={-1} id="logs-modal" ref={logsModalRef}>
                        <div className="modal-dialog modal-dialog-centered modal-xl">
                            <div className="modal-content">
                                <div className="modal-body">
                                    <MasterLog from="chat" lead={dataChatPipeline} setShow={setShowAddLogModal} />
                                </div>
                            </div>
                        </div>
                    </div>
                }

                {
                    showAddPipelineModal && phoneNumber && settings.feature_pipeline && menuActive === "chat" &&
                    <AddPipeline merchantId={listChatRooms[phoneNumber].merchants.map((data: ChatMerchant) => data.id)} />
                }
                {
                    showUpdateMerchantModal && phoneNumber && settings.feature_merchant && menuActive === "chat" &&
                    <UpdateMerchant merchant={selectMerchant!} />
                }
                {
                    phoneNumber && settings.feature_merchant && menuActive === "chat" &&
                    <AddMerchant chatWindowData={{ name: listChatRooms[phoneNumber].roomName, phone: phoneNumber.split('-')[0], as: phoneNumber.split('-')[1] }} />
                }
                {
                    attachmentMessageId &&
                    <ChatAttachmentModal messageId={attachmentMessageId} url={attachmentUrl} />
                }
                {
                    showEndSessionModal && menuActive === "chat" && <EndSessionChat />
                }
                {
                    showSwitchSessionModal && menuActive === "chat" && <SwitchSessionChat />
                }
            </div>
            {
                isOpenDetailContact && menuActive === "chat" && <DetailContactChat />
            }
            {
                isOpenDetailGroupContact && menuActive === "chat-group" && <DetailGroupContactChat />
            }
            {
                showModalUpdateGroupMessage && <UpdateGroupMessageBubble message={selectGroupMessage!} />
            }
            {
                showModalUpdateMessage && <UpdateMessageBubble chatMessage={selectMessage!} />
            }
        </div>
    )
}

export { ChatWindow }